
/* —————————————————— CARD PRODUCT —————————————————— */

function cardSelectSwitchColor(cardId, id, url){
  //console.log(id, url);
  var card = $("#" + cardId);

  card.find(".card-media").hide();
  card.find("#media-" + id).show();
  
  card.find(".main").hide();
  card.find("#main-" + id).show();

  card.find(".dh-switch").removeClass("active");
  card.find("#switch-" + id).addClass("active");

  card.find(".options").hide();
  card.find("#options-" + id).show();
}


/* —————————————————— FAQ —————————————————— */

function openFaq(element){
  var el = $(element);

  el.toggleClass("active");
  el.find(".answer").slideToggle();
  
}